export default "__VITE_ASSET__IfcvUNsg__"